//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getFacebookPageId = createSelector(
  (state: ICuralateStore) => state.facebookInstagramSettings.connectedFacebookPageToken,
  (pageToken) => pageToken?.entityId,
);
